;(() => {
  if (window.__lpAppContactBound) return
  window.__lpAppContactBound = true

  const floatingSelector = '[data-app-contact-floating]'

  const getFloatingEntries = () => Array.from(document.querySelectorAll(floatingSelector))

  const updateFloatingOffset = () => {
    let obstructionOffset = 72
    const previewBar = document.querySelector('#preview-bar-iframe')
    const shopifyChat = document.querySelector('shopify-chat')

    for (const obstruction of [previewBar, shopifyChat]) {
      if (!obstruction || typeof obstruction.getBoundingClientRect !== 'function') continue
      const rect = obstruction.getBoundingClientRect()
      const touchesViewportBottom = rect.bottom >= window.innerHeight - 8
      const isViewportSizedHost = rect.height >= window.innerHeight / 2
      if (rect.width > 0 && rect.height > 0 && touchesViewportBottom && !isViewportSizedHost) {
        obstructionOffset = Math.max(obstructionOffset, Math.ceil(rect.height) + 16)
      }
    }

    for (const floatingEntry of getFloatingEntries()) {
      floatingEntry.style.setProperty(
        '--app-contact-obstruction-offset',
        `${obstructionOffset}px`,
      )
    }
  }

  document.addEventListener(
    'click',
    (event) => {
      if (!event.target || typeof event.target.closest !== 'function') return

      const closeButton = event.target.closest('[data-app-contact-close]')
      if (closeButton) {
        const floatingEntry = closeButton.closest(floatingSelector)
        if (floatingEntry) floatingEntry.hidden = true
        return
      }

      const appLink = event.target.closest('[data-app-contact-link]')
      if (!appLink) return

      try {
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          event: 'lp_app_contact_click',
          lp_app: appLink.dataset.appContactApp || 'unknown',
          lp_store: appLink.dataset.appContactStore || 'unknown',
          lp_page_type: appLink.dataset.appContactPageType || 'unknown',
          lp_position: appLink.dataset.appContactPosition || 'unknown',
        })
      } catch (_) {
        // Analytics must never block the native new-tab navigation.
      }
    },
    true,
  )

  const initialize = () => {
    updateFloatingOffset()
    window.setTimeout(updateFloatingOffset, 1500)
    window.setTimeout(updateFloatingOffset, 5000)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true })
  } else {
    initialize()
  }

  document.addEventListener('shopify:section:load', initialize)
  window.addEventListener('load', updateFloatingOffset)
  window.addEventListener('resize', updateFloatingOffset)
})()
